module.exports = __webpack_public_path__ + "media/assets/images/flags/gl-9ee9dd167c6808d60bbdadf692354fb3.svg";